var _linearGradient, _path, _linearGradient2, _circle, _linearGradient3, _circle2, _circle3, _linearGradient4, _rect, _path2, _path3, _path4, _path5, _linearGradient5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GrindingMachine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E1d7Df49iJ1BaFyB2vKFsa",
    x1: 31.542,
    x2: 32.395,
    y1: 20.07,
    y2: 30.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37c6d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a9ba1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E1d7Df49iJ1BaFyB2vKFsa)",
    d: "M41.618,34.412L17,36V20l24.399,0.787C45.078,20.906,48,23.923,48,27.605v0 C48,31.201,45.207,34.18,41.618,34.412z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E1d7Df49iJ1BaFyB2vKFsb",
    x1: 8.597,
    x2: 13.134,
    y1: 21.187,
    y2: 35.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#889097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#848c94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#78828b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64717c"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 29,
    r: 11,
    fill: "url(#E1d7Df49iJ1BaFyB2vKFsb)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E1d7Df49iJ1BaFyB2vKFsc",
    x1: 9.69,
    x2: 12.164,
    y1: 24.738,
    y2: 32.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 29,
    r: 6,
    fill: "url(#E1d7Df49iJ1BaFyB2vKFsc)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 29,
    r: 2,
    fill: "#3c3c3c"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E1d7Df49iJ1BaFyB2vKFsd",
    x1: 11.255,
    x2: 11.644,
    y1: 1.563,
    y2: 16.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323538"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 12,
    x: 9,
    y: 5,
    fill: "url(#E1d7Df49iJ1BaFyB2vKFsd)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M14,3H9C8.448,3,8,3.448,8,4v0c0,0.552,0.448,1,1,1h5c0.552,0,1-0.448,1-1v0C15,3.448,14.552,3,14,3 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f7f7f",
    d: "M30,28v-4c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h0 C29.552,29,30,28.552,30,28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f7f7f",
    d: "M34,28v-4c0-0.552-0.448-1-1-1h0c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h0 C33.552,29,34,28.552,34,28z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0c9cc",
    d: "M6.012,21.511c1.843-1.231,4.163-1.801,6.621-1.366c3.683,0.651,6.635,3.639,7.242,7.33 c0.399,2.424-0.175,4.695-1.384,6.504c-0.534,0.799-0.418,1.865,0.262,2.545l2.253,2.253c2.846-2.912,4.446-7.053,3.883-11.574 c-0.772-6.199-5.739-11.225-11.928-12.069c-4.566-0.623-8.789,0.967-11.744,3.854l2.257,2.257 C4.15,21.923,5.215,22.044,6.012,21.511z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E1d7Df49iJ1BaFyB2vKFse",
    x1: 41.193,
    x2: 41.933,
    y1: 21.287,
    y2: 30.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d7479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323538"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E1d7Df49iJ1BaFyB2vKFse)",
    d: "M41.399,20.787L36,20.613v14.161l5.618-0.362C45.207,34.18,48,31.201,48,27.605 C48,23.923,45.078,20.906,41.399,20.787z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GrindingMachine);
export default __webpack_public_path__ + "static/media/icons8-grinding-machine.4a25bfd3c28e4976a854f99377afd0ff.svg";
export { ForwardRef as ReactComponent };